import React, { useState, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import useTenant from "../../../../hooks/useTenant";
import useAuth from "../../../../hooks/useAuth";
import MenuCard from "../../admin/components/MenuCard";

function MenuAclFields(props) {
  const { fields, selectedPermissions, setSelectedPermissions, employeeUserName } = props;
  const { user, getUserMenusWithRoleId, getUserMenusWithPermissions } = useAuth();
  const [menuResults, setMenuResults] = useState([]);

  console.log(employeeUserName, "selectedPermissions.....");

  const { getTenant, tenant: tenantDetails } = useTenant();

  const { t } = useTranslation();
  const {
    formState: { errors },
    control,
    watch,
    setValue,
  } = useFormContext();

  const tenant = watch("tenant");

  useEffect(() => {
    if (tenant != null && Object.keys(tenant).length != 0) {
      getTenant(tenant.value);
    }
  }, [tenant]);

  const fetchMenuDetails = async () => {
    const menuDetails = await getUserMenusWithRoleId(5); //Employee Role Id
    setMenuResults(menuDetails);
  };

  useEffect(() => {
    fetchMenuDetails();
  }, []);

  return (
    <MenuCard
      menuResults={menuResults}
      selectedPermissions={selectedPermissions}
      setSelectedPermissions={setSelectedPermissions}
    />
  );
}

export default MenuAclFields;
